import apiFetch from '../apiFetch'

export default function (token, dossierId, isHistorical) {
  return apiFetch({ endPoint: `purchaseType?dossierId=${dossierId}&dossierIsHistorical=${isHistorical}`, method: 'GET', body: null, token: token })
}
